var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m126.71 504.14h377.44v-377.44c0-33.703 27.516-61.219 61.219-61.219h69.328c33.703 0 61.219 27.516 61.219 61.219v377.44h377.39c33.703 0 61.219 27.516 61.219 61.219v69.328c0 33.703-27.516 61.219-61.219 61.219h-377.39v377.39c0 33.703-27.516 61.219-61.219 61.219h-69.328c-33.703 0-61.219-27.516-61.219-61.219v-377.39h-377.44c-33.703 0-61.219-27.516-61.219-61.219v-69.328c0-33.703 27.516-61.219 61.219-61.219",
    fillRule: "evenodd",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlack);
export default __webpack_public_path__ + "static/media/PlusBlack.dd1c70df1c65870cc0311ca1973e1875.svg";
export { ForwardRef as ReactComponent };